import AITeacher from './AITeacher';

export default function AITeacherWrapper() {
    return (
        <>
            <AITeacher/>
        </>
    );

}